
import HotDropdown from '~/components/Molecules/Dropdown/Dropdown.vue'

export default {
  name: 'SignInDropdown',

  components: {
    HotDropdown,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
}
